import {StoreType} from '..';
//types
import {IUserOrganizationSettingData} from '../../utils/types';

export const userNotificationSettingSelector = (state: StoreType): IUserOrganizationSettingData | null =>
	state.userNotificationStore.userSetting;
